import Loadable from 'components/core/Loadable';
import PublicRoute from 'components/core/PublicRoute';
import WarrantyLayout from 'layouts/WarrantyLayout';
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import ModelSalaman from 'layouts/ModelSalaman/index';

// Auth
const WarrantyInfoPage = Loadable(lazy(() => import('pages/WarrantyInfo')));


const ProductWarranty: RouteObject = {
  path: 'thong-tin-bao-hanh',
  element: <WarrantyLayout />,
  children: [
    {
      path: ':id',
      element: (
        <PublicRoute>
          <WarrantyInfoPage />
        </PublicRoute>
      ),
    },   
    // {
    //     path: 'product/:warrantyId',
    //   element: <ModelSalaman />,
    // },
    // {
    //   path: 'register',
    //   element: <Register />,
    // },
    // {
    //   path: '/auth/forgot-password',
    //   element: <PasswordRecovery />,
    // },
    // {
    //   path: '/auth/reset-password',
    //   element: <PasswordReset />,
    // },
  ],
};

export default ProductWarranty;
